import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import ThemeConsumer from "../ThemeConsumer"

const DefaultContainer = ({ children, theme, customClass }) => {
  const containerClass = classnames(
    theme.pa6,
    theme.defaultContainer,
    customClass
  )

  return <section className={containerClass}>{children}</section>
}

DefaultContainer.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
  customClass: PropTypes.string
}

export default ThemeConsumer("UIDefaultContainer")(DefaultContainer)



// WEBPACK FOOTER //
// ./src/shared/components/DefaultContainer/index.js